#import "../fragments/edition-fragment.graphql"

mutation UpdateEdition($edition: EditionUpdateInput!) {
    editionUpdate(input: $edition) {
        edition {
            ...EditionFragment
        }
    }
}
